import { DraftConfiguration, DraftState } from '@/types';
import { getConfigurationMaskObjectUrl } from '@/utils/masks/getConfigurationMaskObjectUrl';
import { isDraftDesignConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';

export const removeFilterAction =
  ({ cid }: DraftConfiguration) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftDesignConfiguration(configuration)) {
      configuration.filter = undefined;
      configuration.processedImage = configuration.mask
        ? getConfigurationMaskObjectUrl(cid)
        : undefined;
    }
  };
